import moment from "moment";
import { ALL_DATES_END, ALL_DATES_START } from "./dateRangePresets";

// Shared date math for the "lastWeek" / "thisMonth" / ... presets. This is the
// single definition of what each preset resolves to: DateRangePicker (Reports)
// and getDateFilter (src/utils/index.ts, used by Commission) both delegate
// here, so a preset can never mean two different ranges in two places.
export const resolveDateRangePreset = (
  preset: string,
  customStart: Date | null = null,
  customEnd: Date | null = null
): { start: moment.Moment | null; end: moment.Moment | null } | null => {
  const today = moment().endOf("day");
  let start: moment.Moment | null = null;
  let end: moment.Moment | null = today.clone();

  switch (preset) {
    case "thisWeek":
      start = today.clone().startOf("week");
      break;
    case "lastWeek":
      start = today.clone().subtract(1, "week").startOf("week");
      end = today.clone().subtract(1, "week").endOf("week");
      break;
    case "thisMonth":
      start = today.clone().startOf("month");
      break;
    case "lastMonth":
      start = today.clone().subtract(1, "month").startOf("month");
      end = today.clone().subtract(1, "month").endOf("month");
      break;
    case "last3Months":
      start = today.clone().subtract(3, "months").startOf("month");
      break;
    case "last6Months":
      start = today.clone().subtract(6, "months").startOf("month");
      break;
    case "last12Months":
      start = today.clone().subtract(12, "months").startOf("month");
      break;
    case "lastCalendarYear":
      start = today.clone().subtract(1, "year").startOf("year");
      end = today.clone().subtract(1, "year").endOf("year");
      break;
    case "allDates":
      // "Include all Dates" hides both date pickers, so the range is resolved
      // here rather than coming from the UI. See ALL_DATES_START/END for why
      // this is an explicit wide range instead of "send no dates".
      start = moment(ALL_DATES_START).startOf("day");
      end = moment(ALL_DATES_END).endOf("day");
      break;
    case "custom":
      start = customStart ? moment(customStart) : null;
      end = customEnd ? moment(customEnd) : null;
      break;
    default:
      // Unrecognized preset key — let the caller decide how to handle it.
      return null;
  }

  return { start, end };
};
